import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { startNFTTransaction } from 'controllers/NFTController'

import { getActualGasCost } from 'eth/ethUtils'

import ErrorLine from 'components/ErrorLine'
import { useHistory } from 'react-router-dom'
import { decodeHarmonizeError } from 'eth/ethUtils'
import { getDisplayError } from 'eth/tokenUtils'
import TimerProgress from './TimerProgress'
import { Button, Snackbar } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'

import styles from 'assets/jss/material-kit-react/views/landingPage.js'

import { makeStyles } from '@material-ui/core/styles'
import { getHarmonizeContract } from 'eth/ethUtils'
import { getOptionsMintFee } from 'eth/tokenUtils'
import { getOptionsFee } from 'eth/tokenUtils'
import { mintHarmonize } from 'eth/ethUtils'
import { resetNFT } from 'redux/actions/nftActions'
import { getUint256StringFromHex } from 'eth/tokenUtils'
import { displayError } from 'util/screenUtils'
import { getGweiFromEth } from 'eth/ethUtils'
const useStyles = makeStyles(styles)
export default function MintNFTInProgress() {

  const [actualGasCost, setActualGasCost] = useState()

  const { mediaHash, name, price, tokenId } = useSelector(state => state.nfts)

  const [mintRequested, setMintRequested] = useState(false)
  const [minting, setMinting] = useState(false)
  const [minted, setMinted] = useState(false)
  const [failed, setFailed] = useState(false)
  const [showSnack, setShowSnack] = useState(false)
  const [tokenMessage, setTokenMessage] = useState()
  const [cancelable, setCancelable] = useState(true)

  const [error, setError] = useState('')
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()

  const displayMintError = (error) => {
    return getDisplayError(error, setError)
  }

  const displayMinted = () => {
    return (
      <div
        style={{ borderTop: '1px solid black', paddingTop: 5 }}
        onClick={() => {
          history.replace('/Vault')
        }}
      >
        <h4 style={{ fontWeight: 'bold', textAlign: 'center' }}>
          {`Congratulations! ${name} has been minted`}
        </h4>
        <p style={{ cursor: 'pointer', padding: '1em', textAlign: 'center', color: 'blue' }}>
          Click here to view the NFTs in your vault.
        </p>

      </div>
    )
  }
  const displayCancel = () => {
    if (cancelable) {
      return (
        <Button
          variant='contained'
          color='secondary'
          className={classes.submit}

          onClick={() => {

            cleanup()
            history.goBack()
          }}
        >
          Cancel Minting
        </Button>
      )
    }
  }

  const displayCancelOrInProgress = () => {
    if (!error) {
      if (mintRequested) {
        return (
          <>
            <div
              style={{
                display: 'flex',
                height: '15vh',
                justifyContent: 'center',
              }}
            >
              <TimerProgress height={15} label='Minting...' />

            </div>
            <h3 style={{ textAlign: 'center' }}>
              Minting in Progress, Please Wait
            </h3>

          </>
        )
      } else if (cancelable) {
        return <div style={{
          display: 'flex',
          justifyContent: 'center', padding: '1em'
        }}>
          {displayCancel()}
        </div>
      }
    }
  }

  const displayMintingInProgress = () => {
    return (
      <div
        style={{
          height: '50vh',
          width: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <ErrorLine error={error} />
        {displayCancelOrInProgress()}
        {tokenMessage && (
          <h4 style={{ textAlign: 'center' }}>{tokenMessage}</h4>
        )}
      </div>
    )
  }

  const cleanup = () => {
    dispatch(resetNFT())
  }

  const mintStarted = async () => {
    console.log('mintStarted')
    setTokenMessage(`Minting requested. Please respond to your wallet prompt to continue.`)
    setCancelable(false)
  }

  const txStarted = async (txHash) => {
    console.log(`txStarted txHash ${txHash}`)
    setTokenMessage(`Minting your NFT has started...`)
    setMintRequested(true)
    setCancelable(false)
    try {
      await startNFTTransaction(tokenId, txHash)
    } catch (error) {
      displayError(error,setError)
    }

  }

  const mintCompleted = (receipt) => {
    console.log('minted', receipt)
    setMinting(false)
    setMintRequested(false)
    setMinted(true)
    setTokenMessage(`Minted ${name}`)
    const gasCost = getActualGasCost(receipt)
    setActualGasCost(gasCost)
  }

  const snackClose = () => {
    setShowSnack(false)
    cleanup()
    history.goBack()
  }
  const snackFailed = () => {
    if (showSnack) {
      return (
        <Snackbar open={showSnack} onClose={snackClose}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        >
          <Alert onClose={snackClose} severity='error'>
            <AlertTitle>Mint Failed</AlertTitle>
            <span>The NFT was not minted</span>
          </Alert>
        </Snackbar>
      )
    }
  }
  const mintFailed = (error) => {
    setMinting(false)
    setMintRequested(false)
    setFailed(true)
    const rejected = displayMintError(decodeHarmonizeError(error))
    console.log(`mintFailed ${rejected}`, error)
    if (rejected) {
      cleanup()
      setTokenMessage('')
      history.goBack()
    } else {
      setTokenMessage('Mint Failed')
      setShowSnack(true)
    }
  }

  /**
   * tokenId must be the uint256 string created from the UUID.
   * 
   * @param {*} mintFee 
   */
  const mint = async (mintFee) => {
    if (!(minting || minted)) {
      console.log(`************* mint Harmonize price ${price} mintFee ${mintFee} ***************`)
      setTokenMessage()
      setMinting(true)
      const priceInGwei = getGweiFromEth(price)
      const totalFee = mintFee
      mintStarted()

      try {
        await mintHarmonize(tokenId,
          priceInGwei,
          0,//royalty
          `${getUint256StringFromHex(mediaHash)}`,//hash MUST NOT BE 0
          0,//finger
          '',//id
          [],
          totalFee,
          txStarted,
          mintCompleted,
          mintFailed
        )
      } catch (error) {
        console.error(`Unexpected exception ${typeof(error)} thrown from mintHarmonize`, error)
        mintFailed(error)
      }


    }
  }

  const displayHeader = () => {

    return (
      <div style={{ textAlign: 'center', width: '100%' }}>
        <h3 style={{ lineHeight: 1 }}>Minting {name}</h3>
      </div>
    )
  }
  const displayBody = () => {
    return (
      <>
        {displayHeader()}
        {snackFailed()}
        {minted ? displayMinted()
          : displayMintingInProgress()}
      </>
    )
  }
  const startMint = () => {
    const tru = getHarmonizeContract()

    tru.methods
      .options()
      .call()
      .then((opts) => {
        const fee = getOptionsMintFee(opts)
        const transactionFee = getOptionsFee(opts, 0)
        mint(fee, transactionFee)
      })
  }
  useEffect(() => {
    if (!failed) {
      startMint()
    }

  }, [failed])

  return displayBody()
}
